import type { MessageIOContext } from "./MessageIOContext.js";


export abstract class MessageIn {
    abstract read(
        context: MessageIOContext,
        json: Record<string, any>
    ): void;
}
